/**
 * @param {Object} param
 * @param {boolean} param.isBookmarked
 * @param {() => void} param.toggleAnimate
 * @returns {void}
 */
export const triggerAnimation = ({ isBookmarked, toggleAnimate }) => {
  if (isBookmarked) {
    return;
  }
  toggleAnimate();
  setTimeout(() => toggleAnimate(), 500); // Determine animation
};

/**
 * @export
 * @param {string[]} item
 * @param {*} bookmarkName
 * @returns {void}
 */
export function updateBookmarks(item, bookmarkName) {
  localStorage.setItem(bookmarkName, JSON.stringify(item));
  window.dispatchEvent(new Event('storage'));
}

/**
 * @type {BookmarkCirclePositionsType}
 */
export const BookmarkCirclePositions = {
  TopLeft: {
    size: { height: 5, width: 5 },
    coordinates: { x: '-17px', y: '-12px' },
  },
  TopRight: {
    size: { height: 5, width: 5 },
    coordinates: { x: '22px', y: '-14px' },
  },
  MiddleLeft: {
    size: { height: 3, width: 3 },
    coordinates: { x: '-30px', y: '7px' },
  },
  MiddleRight: {
    size: { height: 3, width: 3 },
    coordinates: { x: '34px', y: '3px' },
  },
  BottomLeft: {
    size: { height: 3, width: 3 },
    coordinates: { x: '-15px', y: '24px' },
  },
  BottomRight: {
    size: { height: 5, width: 5 },
    coordinates: { x: '17px', y: '26px' },
  },
};
